import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Salary Report ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MissingRatesModal = _resolveComponent("MissingRatesModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDownloadSalaryReportForJob && _ctx.handleDownloadSalaryReportForJob(...args))),
      type: "button",
      style: _normalizeStyle(`min-width: ${_ctx.minWidth}px`),
      disabled: _ctx.loading,
      class: "btn btn-sm w-100 w-sm-auto btn-success",
      "aria-expanded": "false"
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : _createCommentVNode("", true),
      _hoisted_3
    ], 12, _hoisted_1),
    (_openBlock(), _createBlock(_component_MissingRatesModal, {
      onSavedRates: _ctx.handleSaveRates,
      missingRates: _ctx.missingRates,
      key: _ctx.modalkey
    }, null, 8, ["onSavedRates", "missingRates"]))
  ], 64))
}